module.exports = __webpack_public_path__ + "img/call2.e68410b0.svg";